import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const SalesTrends = ({ t }) => {
  const data = [
    { name: "يناير", uv: 400, pv: 1000 },
    { name: "فبراير", uv: 300, pv: 1200 },
    { name: "مارس", uv: 200, pv: 900 },
    { name: "أبريل", uv: 278, pv: 1350 },
    { name: "مايو", uv: 189, pv: 1800 },
    { name: "يونيو", uv: 239, pv: 1500 },
  ];
  return (
    <section className="border-[#D1A8551A] w-full border  rounded-2xl p-3 xl:p-6 shadow-md mainLinear">
      <h2 className="my-3 font-semibold text-primary">{t("salesTrends")}</h2>
      <div className="h-[220px]" style={{ minWidth: "100px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 20 }}>
            <defs>
              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5.29%" stopColor="#F9E6BE" />
                <stop offset="49.04%" stopColor="#D1A855" />
                <stop offset="100%" stopColor="#6B562C" />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#374151" strokeDasharray="3 3" />

            <XAxis
              dataKey="name"
              tick={{ fontSize: 12, fill: "#9ca3af" }}
              interval={0}
            />
            <YAxis
              tick={{ fontSize: 12, fill: "#9ca3af", textAnchor: "end", dx: -20 }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#1f2937",
                borderColor: "#111827",
              }}
              cursor={{ fill: "transparent" }}
            />
            <Bar
              dataKey="pv"
              stackId="a"
              fill="url(#barGradient)"
              radius={[6, 6, 0, 0]}
              maxBarSize={30}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};

export default SalesTrends;
